import Skeleton from 'react-loading-skeleton'

// Import the CSS for the skeleton loader
import 'react-loading-skeleton/dist/skeleton.css'

const AchieveSkeleton = ({ variant, ...props }) => {
  return (
    <div
      className={
        '*:first:*:first:data-[variant="transparent"]:bg-[rgba(29_37_47/11%)] [--custom-highlight-background:linear-gradient(90deg,rgba(29_37_47/11%)_40%,rgba(29_37_47/11%)_50%,rgba(29_37_47/11%)_60%)]'
      }
      data-variant={variant}
    >
      <Skeleton {...props} />
    </div>
  )
}

export default AchieveSkeleton
export { AchieveSkeleton }
